<template>
  <div class="d-flex justify-content-between">
    <div class="date">
      <Datepicker
        :input-class="'yearMonthInput-datepicker'"
        :wrapper-class="'lesson-date'"
        :calendar-class="'timesheet-calendar'"
        v-model="yearMonth"
        :minimum-view="'month'"
        :format="'yyyy/MM'"
        name="datepicker"
      />
      <font-awesome-icon :icon="'calendar'" class="calendar"/>
    </div>
  </div>
</template>

<script lang="ts">
import Datepicker from 'vuejs-datepicker';
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import moment, { Moment } from 'moment'

@Component({
  components: {
    Datepicker,
  },
})
export default class YearMonth extends Vue {
  @Prop() value!: Moment

  private get yearMonth(): Date {
    return this.value.toDate()
  }

  private set yearMonth(date: Date) {
    this.$emit('input', moment(date).startOf('month'))
  }
}

</script>

<style scoped>
.date {
  position: relative;
}

.calendar {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 10px;
  cursor:pointer;
  pointer-events: none;
}
</style>

<style>
.yearMonthInput-datepicker {
  padding: 5px 5px 5px 30px;
  position: relative;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  color: black;
  cursor: pointer;
}
</style>
